import { ApiService } from '../../app-lite/api/api.service';
import { TableService }  from '../../app-lite/table/table.service';

import MechanicHtml        from './mechanic.html';
import MechanicClockOnHtml from './mechanic.clock-on.html';
import MechanicsHtml       from './mechanics.html';

export function MechanicsStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'MechanicsCtrl',
    name       : 'app.mechanics',
    templateUrl: MechanicsHtml,
    url        : '/mechanics',
    resolve    : {
      mechanics: ( tableApi : TableService, workshopAPI : ApiService ) : ng.IPromise<any> => {
        const cache = tableApi.getCacheForTable('mechanics');

        return workshopAPI.stream('/filters', [
          cache.filtering.value ? cache.filtering.value : '*',
          'mechanics',
          0,
          cache.paging.pageSize   || 10,
          cache.sorting.field     || 'display_name',
          cache.sorting.direction || 'asc',
          cache.filtering.archived_only ? cache.filtering.archived_only : false
        ]);
      }
    }
  })
  .state({
    controller: 'mechanicCtrl',
    name      : 'app.mechanic',
    params    : {
      id: { squash: true, value: null }
    },
    templateUrl: MechanicHtml,
    url        : '/mechanic/:id',
    resolve    : {
      settings: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_settings'),
      mechanic: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string => $stateParams.id
        ? workshopAPI.get('/mechanic', $stateParams.id)
        : '',
      schedule: ( $stateParams : ng.ui.IStateParamsService, workshopAPI : ApiService ) : ng.IPromise<any> | string => $stateParams.id
        ? workshopAPI.post('/schedule/show_default', { mechanic_ids: [ $stateParams.id ] })
        : ''
    }
  })
  .state({
    controller : 'MechanicClockOnCtrl',
    name       : 'app.mechanic-clock-on',
    templateUrl: MechanicClockOnHtml,
    url        : '/mechanics_clock_on'
  });
};